import { createSlice } from '@reduxjs/toolkit';

import initialState, * as handlers from './handlers';

const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthParams: handlers.setAuthParams,
  },
});

export const { actions, reducer } = auth;
export const { setAuthParams } = actions;

export default reducer;
